<template>
  <div class="container">
    <TopNav class="mt-4" />
    <FacebookPixelIntegration />
  </div>
</template>

<script>
import Vue from 'vue';

import TopNav from '@/web/components/navigation/TopNav.vue';
import FacebookPixelIntegration from '@/web/components/settings/FacebookPixelIntegration.vue';

export default Vue.extend({
  components: {
    TopNav,
    FacebookPixelIntegration,
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
